// src/flow/carouselDefaults.js
// The carousel's starting look. One place, used by the shared state and the
// preview.
import { DEFAULT_PALETTE_ID } from "../carousel/palettes";
import { DEFAULT_FONT_PAIR_ID, DEFAULT_SIZES } from "../carousel/fonts";
import { DEFAULT_LAYOUT_ID, DEFAULT_LINE_WEIGHT } from "../carousel/drawSlide";
import {
  DEFAULT_BG_STYLE_ID,
  DEFAULT_BG_OPTIONS,
  DEFAULT_BG_OVERLAY,
} from "../carousel/backgrounds";

// Everything the person can change about the carousel's look.
// Starts in the Clean layout with the Light palette.
export const CAROUSEL_DEFAULT_DESIGN = {
  layoutId: DEFAULT_LAYOUT_ID,
  paletteId: DEFAULT_PALETTE_ID,
  customPalette: null,
  fontPairId: DEFAULT_FONT_PAIR_ID,
  sizes: DEFAULT_SIZES,
  lineWeight: DEFAULT_LINE_WEIGHT,
  bgStyle: DEFAULT_BG_STYLE_ID,
  bgOptions: DEFAULT_BG_OPTIONS,
  bgOverlay: DEFAULT_BG_OVERLAY,
  bgBitmap: null,
};

// Logo box as fractions of the slide:
// left edge 0.76 + width 0.18 = 0.94 → 6% right margin
export const CAROUSEL_DEFAULT_LOGO_REL = {
  xPct: 0.76,
  yPct: 0.06,
  wPct: 0.18,
  opacity: 1,
};